<template>
    <section>
        <div class="max-w-6xl mx-auto px-5 py-24 ">
            <div class="text-center mb-20">
                <Title>BUK Nancy Games</Title>
                <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">Une petit app pour les maîtres du jeu :)</p>
                <div class="flex mt-6 justify-center">
                    <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
                </div>
            </div>
            <div class="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 ">
                <GameCard :to="{ name: 'beret-prepare' }">Beret</GameCard>
                <GameCard :to="{ name: 'loups-garous-prepare' }">Loups Garous</GameCard>
                <GameCard :to="{ name: 'love-letter-prepare' }">Love Letter</GameCard>
            </div>
        </div>
    </section>
</template>
<script>
import GameCard from '@/components/GameCard'
export default {
    components: {
        GameCard
    }
}
</script>